function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.4545 15H15.5455C13.5875 15 12 16.4925 12 18.3333V31.6667C12 33.5075 13.5875 35 15.5455 35H34.4545C36.4125 35 38 33.5075 38 31.6667V18.3333C38 16.4925 36.4125 15 34.4545 15ZM34.4545 17.2222C34.5902 17.2222 34.7184 17.2481 34.8395 17.2875L25 24.6881L15.1605 17.2875C15.2819 17.2481 15.4098 17.2222 15.5455 17.2222H34.4545ZM34.4545 32.7778H15.5455C14.8925 32.7778 14.3636 32.2806 14.3636 31.6667V19.5342L24.2617 26.9786C24.4773 27.1411 24.7388 27.2222 25 27.2222C25.2612 27.2222 25.5227 27.1411 25.7383 26.9786L35.6364 19.5342V31.6667C35.6364 32.2806 35.1075 32.7778 34.4545 32.7778Z",
  fill: "#F3B541"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 23.5,
  stroke: "#F3B541",
  strokeWidth: 3
});

var SvgIconMail = function SvgIconMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mail.32f4aa07.svg";
export { ForwardRef as ReactComponent };